import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Star, Quote } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  return (
    <section id="testimonials" className="py-20 lg:py-28 bg-secondary/40" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.2em] text-bee-orange font-semibold mb-3">Testimonials</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
              What our clients
              <br />
              <span className="text-bee-teal">say about us.</span>
            </h2>
          </div>
          <div className="flex items-center gap-2" data-testid="testimonial-rating-summary">
            <div className="flex">
              {[1, 2, 3, 4, 5].map((i) => (
                <Star key={i} className="h-5 w-5 fill-bee-orange text-bee-orange" />
              ))}
            </div>
            <div className="text-sm font-semibold">Rated 4.9 by 100+ Clients</div>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <div
              key={t.id}
              data-testid={`testimonial-card-${i}`}
              className="relative rounded-2xl bg-card border border-border p-6 card-lift"
            >
              <Quote className="absolute top-5 right-5 h-8 w-8 text-bee-teal/15" />
              <div className="flex mb-3">
                {Array.from({ length: t.rating || 5 }).map((_, k) => (
                  <Star key={k} className="h-4 w-4 fill-bee-orange text-bee-orange" />
                ))}
              </div>
              <p className="text-sm leading-relaxed text-foreground/90">&ldquo;{t.quote}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-border">
                <div className="font-display font-bold">{t.author_name}</div>
                <div className="text-xs text-muted-foreground">{t.author_title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
